import styled from 'styled-components'
const ARTICLE_ID = '1'
const BASE_URL = 'https://interaktiv.tagesanzeiger.ch/2022/ukraine-kraftwerke-videos/'
export const Video = ({
  filename,
  source,
}: {
  filename: string
  source: string
}) => {
  return (
    <>
      <VideoElement controls playsInline preload="metadata">
        <source src={BASE_URL + `${filename}.mp4#t=0.5`} type='video/mp4' />
        <source src={BASE_URL + `${filename}.webm#t=0.5`} type='video/webm' />
      </VideoElement>
      <VideoSource>
        Quelle: <a href={source}>Twitter</a>
      </VideoSource>
    </>
  )
}
const VideoElement = styled.video`
width: 100%;
max-height: 500px;
margin-top: 1em;
`
const VideoSource = styled.div`
  font-family: var(--font-plex);
  font-size: 12px;
  color: var(--gray-3);
  a {
    color: var(--blue-main);
    text-decoration: none;
  }
`
